import { useTranslation } from 'react-i18next';

import { TripArrayFieldNotesInput } from './TripArrayFieldNotesInput';

export function PickupNotesField({ index }: { index: number }) {
  const { t } = useTranslation('common');
  return (
    <TripArrayFieldNotesInput
      index={index}
      tripField="pickupNotes"
      label={t('reservation.notes')}
    />
  );
}
